import React, { forwardRef } from 'react';
import * as S from './style';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const RotatingBanner = forwardRef(({ children, slidesToShow, slidesToScroll, ...rest }, ref) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow,
    slidesToScroll,
    nextArrow: <ArrowForwardIosIcon />,
    prevArrow: <ArrowBackIosIcon />,
    pauseOnHover: true,
    pauseOnFocus: false,
    swipe: true,
    touchMove: true,
    ...rest, // inclui `afterChange`, etc.
  };

  return <S.SliderBox ref={ref} {...settings}>{children}</S.SliderBox>;
});
